import { useId } from 'react';
import { type PictogramIconProps } from './types';

// download_arrow
export const DownloadArrow = ({ color }: PictogramIconProps) => {
  const maskId = useId();

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id={maskId}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="54"
        height="54"
      >
        <rect width="53.5273" height="53.1091" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M26.7636 34.1038C26.4949 34.1038 26.2447 34.0612 26.0132 33.976C25.7816 33.8912 25.5613 33.7452 25.3524 33.5379L18.4173 26.6569C18.0857 26.3276 17.922 25.9424 17.9261 25.5013C17.9305 25.0602 18.0943 24.6679 18.4173 24.3246C18.7634 23.9816 19.1607 23.8044 19.6094 23.7929C20.0584 23.7815 20.456 23.9475 20.802 24.2908L25.0909 28.5462V11.6177C25.0909 11.1467 25.2511 10.7524 25.5716 10.4349C25.8916 10.117 26.289 9.95801 26.7636 9.95801C27.2383 9.95801 27.6357 10.117 27.9557 10.4349C28.2762 10.7524 28.4364 11.1467 28.4364 11.6177V28.5462L32.7252 24.2908C33.0572 23.9618 33.451 23.7994 33.9068 23.8034C34.3629 23.8079 34.7639 23.9816 35.11 24.3246C35.433 24.6679 35.6003 25.0567 35.6118 25.4908C35.6233 25.9249 35.4561 26.3136 35.11 26.6569L28.1749 33.5379C27.966 33.7452 27.7457 33.8912 27.5141 33.976C27.2826 34.0612 27.0324 34.1038 26.7636 34.1038ZM14.0682 43.1512C12.9415 43.1512 11.9879 42.7639 11.2073 41.9894C10.4267 41.2149 10.0364 40.2687 10.0364 39.1509V34.8103C10.0364 34.3393 10.1966 33.9451 10.517 33.6275C10.8371 33.3096 11.2344 33.1506 11.7091 33.1506C12.1838 33.1506 12.5812 33.3096 12.9012 33.6275C13.2216 33.9451 13.3818 34.3393 13.3818 34.8103V39.1509C13.3818 39.3213 13.4534 39.4773 13.5965 39.6189C13.7392 39.7609 13.8965 39.8319 14.0682 39.8319H39.4591C39.6308 39.8319 39.7881 39.7609 39.9308 39.6189C40.0739 39.4773 40.1455 39.3213 40.1455 39.1509V34.8103C40.1455 34.3393 40.3057 33.9451 40.6261 33.6275C40.9461 33.3096 41.3435 33.1506 41.8182 33.1506C42.2929 33.1506 42.6902 33.3096 43.0103 33.6275C43.3307 33.9451 43.4909 34.3393 43.4909 34.8103V39.1509C43.4909 40.2687 43.1006 41.2149 42.32 41.9894C41.5394 42.7639 40.5858 43.1512 39.4591 43.1512H14.0682Z"
          fill={color ?? 'currentColor'}
        />
      </g>
    </svg>
  );
};
